import React, { useState } from 'react';
import { Query, Builder, Utils } from 'react-awesome-query-builder';
import transit from 'transit-immutable-js';
import stringify from 'json-stringify-safe';
import config from './config';

import QueryDialog from './QueryDialog';

import './styles.css';

const { queryBuilderFormat, queryString, mongodbFormat } = Utils;
const serializeTree = transit.toJSON;
const loadTree = transit.fromJSON;

export default function QueryBuilder(properties) {
  const [showDebug, setShowDebug] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [queryToSave, setQueryToSave] = useState(null);

  const flatten = arr => {
    return arr.reduce(function(flat, toFlatten) {
      return flat.concat(
        Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten,
      );
    }, []);
  };

  const toQueryBuilderFormat = (field, table, schema) => {
    const newField = {};

    const type = (type => {
      switch (type) {
        case 'text':
          return 'text';
        case 'endpoint':
          return 'endpoint';
        case 'enum':
          return 'select';
        case 'date':
          return 'date';
        case 'number':
          return 'number';
        default:
          return 'text';
      }
    })(field.type);

    const operators = (type => {
      switch (type) {
        case 'text':
          return ['equal', 'not_equal', 'like', 'not_like'];
        case 'endpoint':
          return ['endpoint_equals', 'endpoint_not_equals'];
        case 'enum':
          return ['select_equals', 'select_not_equals'];
        case 'date':
          return [
            'equal',
            'greater',
            'less',
            'lt_now_minus_days',
            'gt_now_minus_days',
          ];
        case 'number':
          return ['equal', 'greater', 'less'];
        default:
          return ['equal', 'not_equal', 'like', 'not_like'];
      }
    })(field.type);

    const valueSources = (type => {
      switch (type) {
        case 'text':
          return ['value'];
        case 'enum':
          return ['value'];
        case 'date':
          return ['value'];
        default:
          return ['value'];
      }
    })(field.type);

    const listValues = (values => {
      if (values) {
        let vals = {};
        values.forEach(val => {
          vals = { ...vals, [val]: val };
        });
        return vals;
      }
      return {};
    })(field.values);

    const fieldName = `${schema}|${table}|${field.field}`;
    newField[fieldName] = {
      label: `${field.field} (${table})`,
      type,
      valueSources,
      operators,
      defaultOperator: operators ? operators[0] : '',
      table,
      schema,
    };

    if (type === 'select') {
      newField[fieldName].listValues = listValues;
      delete newField[fieldName].valueSources;
    }

    if (type === 'endpoint') {
      newField[fieldName].widgets = {
        endpoint: {
          widgetProps: {
            url: field.url,
            typeahead: properties.typeahead,
          },
        },
      };
    }

    return newField;
  };

  const getChildren = props => {
    const jsonStyle = {
      backgroundColor: 'darkgrey',
      margin: '10px',
      padding: '10px',
    };

    return (
      <div>
        <div className="query-builder">
          <Builder {...props} />
        </div>
        <div className="clearfix">
          <a
            className="btn btn-default"
            onClick={() => {
              setShowModal(true);
              setQueryToSave(serializeTree(props.tree));
            }}
          >
            <i className="fa fa-save" /> Save Search
          </a>
          <a
            className="pull-left hide"
            style={{ color: '#555555' }}
            onClick={() => setShowDebug(!showDebug)}
          >
            DEBUG
          </a>
          <button
            className="btn btn-primary btn-lg pull-right query-builder-search-btn"
            onClick={() => properties.onSearch(stringify(props.tree))}
          >
            Search
          </button>
        </div>
        <h2 style={{ paddingBottom: '15px', paddingTop: '10px' }}>
          Search Result
        </h2>
        <div id="debug" className={showDebug ? 'show' : 'hide'}>
          <div>
            stringFormat:
            <pre style={jsonStyle}>
              {stringify(queryString(props.tree, props.config), undefined, 2)}
            </pre>
          </div>
          <div>
            humanStringFormat:
            <pre style={jsonStyle}>
              {stringify(
                queryString(props.tree, props.config, true),
                undefined,
                2,
              )}
            </pre>
          </div>
          <div>
            mongodbFormat:
            <pre style={jsonStyle}>
              {stringify(mongodbFormat(props.tree, props.config), undefined, 2)}
            </pre>
          </div>
          <div>
            queryBuilderFormat:
            <pre style={jsonStyle}>
              {stringify(
                queryBuilderFormat(props.tree, props.config),
                undefined,
                2,
              )}
            </pre>
          </div>
          <div>
            Tree:
            <pre style={jsonStyle}>{stringify(props.tree, undefined, 2)}</pre>
          </div>
          <div>
            Serialized Tree:
            <div style={jsonStyle}>{serializeTree(props.tree)}</div>
          </div>
        </div>
      </div>
    );
  };

  let fields = {};
  if (properties.targets && properties.targets.sources) {
    properties.targets.sources.forEach(source => {
      source.items.forEach(el => {
        fields = {
          ...fields,
          ...toQueryBuilderFormat(el, source.table, source.schema),
        };
      });
    });
  }

  const { tree, ...config_props } = { ...config, fields };

  return (
    <div>
      <QueryDialog
        show={showModal}
        initialValues={{ query: queryToSave }}
        onSubmit={e => {
          properties.addQuery(e);
          setShowModal(false);
        }}
        onClose={() => {
          setShowModal(false);
          setQueryToSave(null);
        }}
      />
      <Query
        value={loadTree(properties.initValue)}
        {...config_props}
        get_children={getChildren}
        onChange={el => properties.onChange(transit.toJSON(el))}
      >
        {' '}
      </Query>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/management/components/QueryBuilder/QueryBuilder.js